import { IntlShape } from 'react-intl'

import { AmbianceEnum, HouseTypeEnum } from '../../../../lib/graphql'

export const getHouseTypeOptions = (intl: IntlShape) => {
  return [
    {
      label: intl.formatMessage({
        id: 'ui.houseSearchFilterCheckbox.utils.hotel',
        defaultMessage: 'Hôtel',
      }),
      name: HouseTypeEnum.HOTEL,
    },
    {
      label: intl.formatMessage({
        id: 'ui.houseSearchFilterCheckbox.utils.receptionHall',
        defaultMessage: 'Lieu de réception',
      }),
      name: HouseTypeEnum.RECEPTION_HALL,
    },
    {
      label: intl.formatMessage({
        id: 'ui.houseSearchFilterCheckbox.utils.selfManaged',
        defaultMessage: 'Lieu en gestion libre',
      }),
      name: HouseTypeEnum.SELF_MANAGED,
    },
    {
      label: intl.formatMessage({
        id: 'ui.houseSearchFilterCheckbox.utils.seminars',
        defaultMessage: 'Lieu de séminaire',
      }),
      name: HouseTypeEnum.SEMINARS,
    },
    {
      label: intl.formatMessage({
        id: 'ui.houseSearchFilterCheckbox.utils.villageEcolodge',
        defaultMessage: 'Village / ecolodge',
      }),
      name: HouseTypeEnum.VILLAGE_ECOLODGE,
    },
  ]
}

export const getHouseAmbianceOptions = (intl: IntlShape) => {
  return [
    {
      label: intl.formatMessage({
        id: 'ui.houseSearchFilterCheckbox.utils.countryside',
        defaultMessage: 'Campagne',
      }),
      name: AmbianceEnum.COUNTRYSIDE,
    },
    {
      label: intl.formatMessage({
        id: 'ui.houseSearchFilterCheckbox.utils.beach',
        defaultMessage: 'Mer & océan',
      }),
      name: AmbianceEnum.BEACH,
    },
    {
      label: intl.formatMessage({
        id: 'ui.houseSearchFilterCheckbox.utils.mountain',
        defaultMessage: 'Montagne',
      }),
      name: AmbianceEnum.MOUNTAIN,
    },
    {
      label: intl.formatMessage({
        id: 'ui.houseSearchFilterCheckbox.utils.urban',
        defaultMessage: 'Ville',
      }),
      name: AmbianceEnum.URBAN,
    },
  ]
}
